export default (state = null, action = {}) => {
  switch (action.type) {
    case 'TORNEO_ESTADO_SET':
      return action.payload;
    default:
      return state;
  }
};
